<div class="flex flex-col gap-6">
  <!-- En-tête informatif -->
  <div class="flex flex-col gap-1 text-center sm:text-left">
    <span class="text-xs font-bold uppercase tracking-wider text-indigo-11"> Processus de sélection </span>
    <h3 class="text-lg font-bold text-neutral-12 m-0">Comment se déroule l'attribution du mandat ?</h3>
    <p class="text-xs text-neutral-11 m-0 leading-relaxed">
      Pour garantir une concurrence saine et équitable, l'engagement contractuel définitif n'intervient
      qu'après visite physique du bien.
    </p>
  </div>

  <!-- Timeline verticale spacieuse -->
  <div class="flex flex-col relative pl-2">
    @for (step of steps(); track step.number; let isLast = $last) {
      <div class="flex items-start gap-4 relative pb-5" [class.pb-0]="isLast">
        <!-- Ligne verticale de connexion -->
        @if (!isLast) {
          <div
            class="absolute left-5 top-10 bottom-0 w-[2px] bg-neutral-3 -translate-x-1/2"
            [class.!bg-primary]="step.highlight || step.completed"
          ></div>
        }

        <!-- Cercle numéro / icône -->
        <div
          class="w-10 h-10 rounded-2xl flex items-center justify-center shrink-0 shadow-xs z-10 transition-colors"
          [class.bg-primary]="step.highlight"
          [class.shadow-md]="step.highlight"
          [class.shadow-primary/20]="step.highlight"
          [class.bg-primary/10]="step.completed"
          [class.border-primary/40]="step.completed"
          [class.bg-neutral-2]="!step.highlight && !step.completed"
          [class.border]="!step.highlight"
          [class.border-neutral-3]="!step.highlight && !step.completed"
        >
          <mat-icon
            class="text-lg! w-5! h-5!"
            [class.!text-white]="step.highlight"
            [class.!text-primary]="step.completed"
            [class.!text-neutral-11]="!step.highlight && !step.completed"
          >
            {{ step.icon }}
          </mat-icon>
        </div>

        <!-- Contenu de l'étape -->
        <div
          class="flex-1 p-3.5 rounded-2xl border transition-all"
          [class.border-primary]="step.highlight"
          [class.bg-primary-surface]="step.highlight"
          [class.border-neutral-3]="!step.highlight"
          [class.bg-white]="!step.highlight"
          [class.dark:bg-neutral-2]="!step.highlight"
        >
          <div class="flex items-center justify-between gap-2 flex-wrap mb-1">
            <span class="text-xs font-bold text-neutral-12"> {{ step.number }}. {{ step.title }} </span>
            @if (step.highlight) {
              <span class="text-[10px] font-extrabold text-primary bg-primary/10 px-2 py-0.5 rounded-full">
                {{ step.subtitle }}
              </span>
            } @else if (step.completed) {
              <span class="text-[10px] text-primary font-bold bg-primary/5 px-2 py-0.5 rounded-full">
                {{ step.subtitle }}
              </span>
            } @else {
              <span class="text-[10px] text-neutral-10 font-medium">
                {{ step.subtitle }}
              </span>
            }
          </div>
          <p class="text-xs text-neutral-11 leading-relaxed m-0">
            {{ step.description }}
          </p>
        </div>
      </div>
    }
  </div>

  <!-- Action : J'ai compris -->
  <div class="pt-2">
    <button
      type="button"
      mat-flat-button
      class="primary w-full !py-6 text-sm font-bold shadow-md shadow-primary/20 flex items-center justify-center gap-2 hover:brightness-105 active:scale-[0.99] transition-all"
      (click)="onContinue()"
    >
      <span>{{ continueButtonText() }}</span>
    </button>
  </div>
</div>
